import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var TestPrep = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M35.896 10.26c-.5.1-1.1-.199-1.199-.698l-1.598-5.494C27.005 15.055 16.315 23.145 3.628 25.742c-.5.1-1.099-.2-1.199-.799-.1-.5.2-1.099.8-1.198A42.4 42.4 0 0 0 31.5 2.87l-5.694 1.598c-.5.1-1.1-.2-1.199-.7-.2-.499.1-1.098.7-1.198L33.198.472c.499-.2 1.098.2 1.198.7l2.198 7.89c.2.6-.1 1.099-.7 1.199ZM2.43 34.532c0-.5.399-1 .998-1h7.892c.5 0 1 .4 1 1v8.89c0 .498-.4.998-1 .998H3.428c-.5 0-.999-.4-.999-.999v-8.89Zm1.897.999v6.891h5.994v-6.891H4.327ZM17.015 24.843c0-.5.4-.998.999-.998h7.992c.5 0 .999.399.999.998v18.578c0 .5-.4.999-1 .999h-7.991c-.5 0-1-.4-1-.999V24.843Zm1.998 1v16.58h5.994v-16.58h-5.994ZM31.7 15.155c0-.5.4-.999.999-.999h7.892c.5 0 1 .4 1 .999V43.42c0 .5-.4.999-1 .999H32.7c-.5 0-.999-.4-.999-.999V15.155Zm1.998.999v26.268h5.994V16.154h-5.994Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
TestPrep.displayName = 'TestPrep';
TestPrep.defaultProps = {
  'aria-label': 'TestPrep'
};
export default TestPrep;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/TestPrep.js
// module id = 3932
// module chunks = 11